module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-7.7ffa4a0a.mp3";